import { currencyInput } from '@/_schemas/generic';

import {
  type ProductAndServiceTemplateFormSchema,
  type ProductAndServiceTemplateQuerySchema,
} from '../schemas/products-and-services-template';

export function productAndServiceTemplateQueryToForm({
  product_template_items,
  ...rest
}: ProductAndServiceTemplateQuerySchema): ProductAndServiceTemplateFormSchema {
  return {
    ...rest,
    sku: rest.sku ?? '',
    description: rest.description ?? '',
    product_template_items: (product_template_items ?? []).map((item) => ({
      ...item,
      default_quantity: currencyInput.queryToFormConverter(item.default_quantity),
      default_price: currencyInput.queryToFormConverter(item.default_price),
      product: {
        ...item.product,
        id: item.product?.id ?? -1,
        name: item.product?.name ?? '',
        sku: item.product?.sku ?? '',
        list_price: currencyInput.formToUpdateConverter(item.product?.list_price ? `${item.product?.list_price}` : '0'),
        wholesale_price: currencyInput.formToUpdateConverter(
          item.product?.wholesale_price ? `${item.product?.wholesale_price}` : '0'
        ),
      },
    })),
  };
}
